import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IngestedOrdersQueryParams } from '@model/ingested-order/ingested-order.model';

export abstract class OrdersExportPort {
  abstract exportOrders(params?: IngestedOrdersQueryParams): Observable<Blob>;
}

export const ORDERS_EXPORT_PORT = new InjectionToken<OrdersExportPort>(
  'OrdersExportPort'
);
